export enum WidgetCollapedType {
  COLLAPSED = 'COLLAPSED',
  SEMI_COLLAPSED = 'SEMI_COLLAPSED'
}
